// since there's no dynamic data here, we can prerender
// it so that it gets served as a static asset in production
export const ssr = true
export const prerender = true

import { getServerLocale } from '~/utils/getServerLocale'
import type { PageLoad } from '../../$types'
import { ContentManagerSystem } from '../../../config/content-manager-system'

const requestManagerSystem = ContentManagerSystem(`
query ServiceQuery($locale: SiteLocale = pt_BR) {
  servicePage(locale: $locale) {
    id
    title
    description

    metadata {
      title
      description
    }

    shelfTitle
    shelf {
      id
      icon
      title
      description
      slug
    }
  }
}
`)

export const load: PageLoad = async (request) => {
  const params = request.params

  const locale = getServerLocale(params.locale as string)

  const response = await requestManagerSystem({ locale: locale.contentManagerSystem })

  return response.servicePage
}

export function entries() {
  return [{ locale: 'pt-br' }]
}
